
























































































































































































































































































































































import mixins from 'vue-typed-mixins'
import DraftActions from '@/builder/mixins/DraftActions'
import { DraftActionsType } from '@/calendesk/models/DraftActionsType'
import { DraftConfigurationType } from '@/calendesk/models/BuilderTypes'
import PlanActions from '@/builder/mixins/PlanActions'
import { DraftConfiguration } from '@/calendesk/models/DraftConfiguration'
import { BuilderSelectType } from '@/calendesk/models/BuilderSelectType'
import DefaultLanguages from '@/calendesk/models/DefaultLanguages'
import { WebsiteLanguageType } from '@/calendesk/models/WebsiteLanguageType'
import CalendeskInformationMessage from '@/lib/calendesk-js-library/components/CalendeskInformationMessage.vue'
import SettingTooltip from '@/components/Tools/SettingTooltip.vue'
import getLanguageName from '@/calendesk/tools/getLanguageName'
import { panelsToOpen, rememberOpenPanels } from '@/builder/sidebar/settingGroupState'
import SidebarDetails from '@/calendesk/models/SidebarDetails'
import { SidebarDetailsType } from '@/builder/sidebar/sidebarDetails/SidebarDetailsType'
import { trans } from '@/lib/calendesk-js-library/prototypes/trans'
import {
  COOKIE_BANNER_CONFIGURATION_ID,
  COOKIE_BANNER_CONFIGURATION_KEY,
  COOKIE_BANNER_ENABLED_KEY,
  COOKIE_BANNER_REVISION_KEY,
  CUSTOM_CODE_ALWAYS,
  CUSTOM_CODE_MODE_KEY,
  ConsentCategory,
  GOOGLE_TAG_MODE_KEY,
  GoogleTagMode,
  cookieBannerPrefill,
  visibleCategories
} from '@/calendesk/models/CookieBannerSettings'

export default mixins(DraftActions, PlanActions).extend({
  name: 'General',
  components: { CalendeskInformationMessage, SettingTooltip },
  data () {
    return {
      googleTagIdEnabled: false,
      // Every group starts collapsed, so the tab opens as a list of group
      // names that fits the 360px drawer without scrolling. Groups the user
      // has opened or collapsed before keep that state.
      openPanels: [] as Array<number>,
      panelsRestored: false,
      groupIds: [
        'general:website',
        'general:booking',
        'general:client_account',
        'general:header_footer',
        'general:advanced'
      ],
      groups: {
        website: [
          'wb_primary_language__select__',
          'wb_favicon_url__text__',
          'wb_website_description__long_text__'
        ],
        booking: [
          'wb_hide_booking_employees__checkbox__',
          'wb_hide_booking_time_to__checkbox__',
          'wb_hide_time_zone__checkbox__',
          'wb_enable_discounts__checkbox__',
          'wb_hide_booking_prices__checkbox__'
        ],
        clientAccount: [
          'wb_hide_login__checkbox__',
          'wb_hide_signup__checkbox__',
          'wb_hide_payments__checkbox__',
          'wb_hide_profile_billing_data__checkbox__',
          'wb_hide_profile_photo_upload__checkbox__'
        ],
        headerFooter: [
          'wb_hide_header__checkbox__',
          'wb_hide_footer__checkbox__'
        ]
      },
      tools: [
        DraftConfigurationType.SELECT,
        DraftConfigurationType.TEXT,
        DraftConfigurationType.LONG_TEXT,
        DraftConfigurationType.CHECKBOX
      ],
      mode: DraftActionsType.CONFIGURATION,
      draftConfigurationType: DraftConfigurationType
    }
  },
  watch: {
    openPanels (indexes: Array<number>) {
      // The state restored in created() is not a choice the user made, so it
      // must not be written back as one: that would freeze today's default
      // for everyone who ever opened this tab.
      if (this.panelsRestored) {
        rememberOpenPanels(this.groupIds, indexes)
      }

      this.panelsRestored = true
    }
  },
  computed: {
    cookieBannerEnabled (): boolean {
      return this.draftConfiguration[COOKIE_BANNER_ENABLED_KEY] === true
    },
    hasGoogleTagId (): boolean {
      return Boolean(this.draftConfiguration.wb_google_tag_id__text__)
    },
    hasCustomCode (): boolean {
      return Boolean(this.draftConfiguration.wb_custom_code__long_text__)
    },
    googleTagMode (): string {
      return this.draftConfiguration[GOOGLE_TAG_MODE_KEY]?.value === GoogleTagMode.AFTER_CONSENT
        ? GoogleTagMode.AFTER_CONSENT
        : GoogleTagMode.IMMEDIATELY
    },
    customCodeMode (): string {
      return this.draftConfiguration[CUSTOM_CODE_MODE_KEY]?.value || CUSTOM_CODE_ALWAYS
    },
    googleTagModeItems (): Array<Record<string, string>> {
      return [
        { text: this.$trans('wb_google_tag_mode_after_consent'), value: GoogleTagMode.AFTER_CONSENT },
        { text: this.$trans('wb_google_tag_mode_immediately'), value: GoogleTagMode.IMMEDIATELY }
      ]
    },
    customCodeModeItems (): Array<Record<string, string | boolean>> {
      const visible = visibleCategories(this.draftConfiguration[COOKIE_BANNER_CONFIGURATION_KEY])
      const item = (category: ConsentCategory) => ({
        text: this.$trans(`wb_custom_code_mode_${category}`) + (visible.includes(category) ? '' : ` (${this.$trans('wb_cookie_banner_category_hidden')})`),
        value: category,
        disabled: !visible.includes(category)
      })

      return [
        { text: this.$trans('wb_custom_code_mode_always'), value: CUSTOM_CODE_ALWAYS, disabled: false },
        item(ConsentCategory.FUNCTIONALITY),
        item(ConsentCategory.ANALYTICS),
        item(ConsentCategory.MARKETING)
      ]
    }
  },
  created () {
    this.googleTagIdEnabled = this.googleTagAvailable
    this.openPanels = panelsToOpen(this.groupIds, { filtering: false })
  },
  methods: {
    configsForGroup (keys: Array<string>): Array<DraftConfiguration> {
      return keys
        .map((key: string) => this.configuration.find((config: DraftConfiguration) => config.key === key))
        .filter(Boolean) as Array<DraftConfiguration>
    },
    getItemsForSelectType (type: BuilderSelectType): Array<Record<string, number | string>> {
      switch (type) {
        case BuilderSelectType.LANGUAGE:
          return DefaultLanguages()
      }

      return []
    },
    getTitleForSelectType (type: BuilderSelectType): string | null {
      switch (type) {
        case BuilderSelectType.LANGUAGE:
          return this.$trans('c_language_select_label')
      }

      return null
    },
    getObjectForSelectTypeAndValue (type: BuilderSelectType, value: WebsiteLanguageType | string): Record<string, any> | string | null {
      switch (type) {
        case BuilderSelectType.LANGUAGE:
          return {
            text: getLanguageName(value as WebsiteLanguageType),
            value
          }
      }

      return null
    },
    updateCheckboxValue (config: DraftConfiguration) {
      const protectedSections = [
        'wb_hide_header__checkbox__',
        'wb_hide_footer__checkbox__',
        'wb_hide_time_zone__checkbox__'
      ]

      if (protectedSections.includes(config.key) && !this.hideSectionsAvailable) {
        this.openFeatureNotAvailableDialog()
      } else {
        this.updateConfigurationProperty(config.key, config.value, true)
      }
    },
    updateGeneralConfigurationPropertyForSelect (key: string, value: any, selected: any) {
      value.value = selected.value
      this.$store.dispatch('setup/updateLanguage', value.value, { root: true }).then(() => {
        this.updateConfigurationPropertyForSelect(key, value, selected)
      })
    },
    updateCustomCode (value: string) {
      const changed = value !== this.draftConfiguration.wb_custom_code__long_text__

      this.updateConfigurationProperty('wb_custom_code__long_text__', value)

      if (changed) {
        this.bumpCookieBannerRevision()
      }
    },
    // What the site loads has changed: visitors who already answered the
    // banner are asked again. Text-only edits never call this.
    bumpCookieBannerRevision () {
      if (!this.cookieBannerEnabled) {
        return
      }

      const current = this.draftConfiguration[COOKIE_BANNER_REVISION_KEY]
      this.updateConfigurationProperty(COOKIE_BANNER_REVISION_KEY, (typeof current === 'number' ? current : 0) + 1)
    },
    updateGoogleTagMode (value: string) {
      this.updateGeneralConfiguration(GOOGLE_TAG_MODE_KEY, { type: BuilderSelectType.GOOGLE_TAG_MODE, value })
      this.bumpCookieBannerRevision()
    },
    updateCustomCodeMode (value: string) {
      this.updateGeneralConfiguration(CUSTOM_CODE_MODE_KEY, { type: BuilderSelectType.CONSENT_CATEGORY, value })
      this.bumpCookieBannerRevision()
    },
    updateCookieBannerEnabled (enabled: boolean) {
      this.flushPendingProperties()

      if (enabled) {
        const prefill = cookieBannerPrefill(this.draftConfiguration, trans)

        if (Object.keys(prefill.texts).length > 0) {
          this.$store.dispatch('builder/updateDraftExternalConfigurationProperty', {
            property: prefill.texts,
            externalConfigurationId: COOKIE_BANNER_CONFIGURATION_ID
          })
        }

        this.$store.dispatch('builder/updateDraftConfigurationProperty', {
          ...prefill.topLevel,
          [COOKIE_BANNER_ENABLED_KEY]: true
        })
        return
      }

      this.updateGeneralConfiguration(COOKIE_BANNER_ENABLED_KEY, false)
    },
    openCookieBannerTexts () {
      this.$store.dispatch('builder/setExternalConfiguration', COOKIE_BANNER_CONFIGURATION_ID)
      this.openSidebarDetails(new SidebarDetails(true, SidebarDetailsType.COOKIE_BANNER, {}))
    }
  }
})
